import DataSource from "../DataSource/DataSource";

export default class OdberneMiestoOpravnenaOsobaService {
  constructor(server){
    this.server = server;
  }

  get(id){
  	return this.server("odbernemiesto.opravena.osoba.get", {id: id});
  }
 

  save(id, item){
    return this.server("odbernemiesto.opravnena.osoba.update", {id: id, data: item});
  }

  getUrovneOpravnenia() {
    return this.server("odbernemiesto.opravnena.osoba.uroven.opravnenia.get.all", {});
  }

  getOdberneMiestoOteCheck(opmEan) {
    return this.server("odbernemiesto.ean.exist.check", {opmEan:opmEan});
  }

  remove(id) {
    return this.server("odbernemiesto.opravnena.osoba.remove", {id:id});
  }

}


// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoOpravnenaOsobaService.js